import(/* webpackMode: "eager" */ "/vercel/path0/src/app/menu/page.tsx");
